export default "__VITE_ASSET__b78291e3__"